import styled from '@emotion/styled';
import {mixinFlexboxColumn, mixinFlexboxRow} from 'webapp-lib/styling';

export const ActiveFilterRow = styled.div`
  ${mixinFlexboxRow};
  gap: var(--gutter);
`;

export const ActiveFilterColumn = styled.div`
  ${mixinFlexboxColumn};
  gap: var(--gutter-small);
`;
